import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import authReducer from "./slice/authSlice";
import projectReducer from "./slice/projectSlice";
import teamManagementReducer from "./slice/teamManagementSlice";

import authAPI from "./services/authAPI";
import userAPI from "./services/userAPI";
import emailTemplateAPI from "./services/emailTemplateAPI";
import projectManagementAPI from "./services/projectManagementAPI";
import customerAPI from "./services/customerAPI";
import RoleManagement from "./services/RoleManagement";
import projectTeamManagementAPI from "./services/projectTeamManagementAPI";
import organizationAPI from "./services/organizationAPI";
import projectComponentAPI from "./services/projectComponentAPI";
import projectVersionAPI from "./services/projectVersionAPI";
import taskTypeAPI from "./services/taskTypeAPI";
import projectModuleAPI from "./services/projectModuleAPI";
import priorityAPI from "./services/priorityAPI";
import taskAPI from "./services/taskAPI";
import projectStatusAPI from "./services/projectStatusAPI";
import taskStatusAPI from "./services/taskStatusAPI";
import teamAPI from "./services/teamAPI";
import teamMemberAPI from "./services/teamMemberAPI";
import teamProjectsAPI from "./services/teamProjectsAPI";
import teamPlanningAPI from "./services/teamPlanningAPI";
import taskCommentsAPI from "./services/taskCommentsAPI";
import backLogAPI from "./services/backLogAPI";
import taskattachmentAPI from "./services/taskattachmentAPI";
import commonAPI from "./services/commonAPI";
import timeSheetLogAPI from "./services/timeSheetLogAPI";
import tasktodoAPI from "./services/tasktodoAPI";
import teamResourcePlanningAPI from "./services/teamResourcePlanningAPI";
import teamTaskAPI from "./services/teamTaskAPI";
import teamboardAPI from "./services/teamboardAPI";
import attachedTaskAPI from "./services/attachedTaskAPI";
import bugTaskAPI from "./services/bugTaskAPI";
import securityPermissionAPI from "./services/securityPermissionAPI";
import ProjectDomain from "./services/projectDomainAPI";
import projectTypeAPI from "./services/projectTypeAPI";
import projectEnvironment from "./services/projectenvironmentAPI";
import projectSynergyAPI from "./services/projectSynergyAPI";
import resetPasswordAPI from "./services/ResetPasswordAPI";
import teamOverviewApi from "./services/teamOverviewAPI";
import projectOverviewAPI from "./services/projectOverviewAPI";
import planningStatusAPI from "./services/planningStatusAPI";
import statusCategoryAPI from "./services/statusCategoryAPI";
import timesheetReportAPI from "./services/timesheetReportAPI";
import planningReportAPI from "./services/planningReportAPI";
import dashboardAPI from "./services/dashboardAPI";
import groupManagementAPI from "./services/groupManagementAPI";
import groupProjectAPI from "./services/groupProjectAPI";
import groupMemberAPI from "./services/groupMemberAPI";


export const store = configureStore({
    reducer: {
        auth: authReducer,
        project: projectReducer,
        teamProjectManagement: teamManagementReducer,
        [authAPI.reducerPath]: authAPI.reducer,
        [userAPI.reducerPath]: userAPI.reducer,
        [projectManagementAPI.reducerPath]: projectManagementAPI.reducer,
        [projectTeamManagementAPI.reducerPath]: projectTeamManagementAPI.reducer,
        [customerAPI.reducerPath]: customerAPI.reducer,
        [RoleManagement.reducerPath]: RoleManagement.reducer,
        [emailTemplateAPI.reducerPath]: emailTemplateAPI.reducer,
        [resetPasswordAPI.reducerPath]: resetPasswordAPI.reducer,
        [organizationAPI.reducerPath]: organizationAPI.reducer,
        [projectComponentAPI.reducerPath]: projectComponentAPI.reducer,
        [projectVersionAPI.reducerPath]: projectVersionAPI.reducer,
        [taskTypeAPI.reducerPath]: taskTypeAPI.reducer,
        [projectModuleAPI.reducerPath]: projectModuleAPI.reducer,
        [priorityAPI.reducerPath]: priorityAPI.reducer,
        [taskAPI.reducerPath]: taskAPI.reducer,
        [projectStatusAPI.reducerPath]: projectStatusAPI.reducer,
        [taskStatusAPI.reducerPath]: taskStatusAPI.reducer,
        [teamAPI.reducerPath]: teamAPI.reducer,
        [teamMemberAPI.reducerPath]: teamMemberAPI.reducer,
        [teamProjectsAPI.reducerPath]: teamProjectsAPI.reducer,
        [teamPlanningAPI.reducerPath]: teamPlanningAPI.reducer,
        [teamOverviewApi.reducerPath]: teamOverviewApi.reducer,
        [taskCommentsAPI.reducerPath]: taskCommentsAPI.reducer,
        [backLogAPI.reducerPath]: backLogAPI.reducer,
        [taskattachmentAPI.reducerPath]: taskattachmentAPI.reducer,
        [commonAPI.reducerPath]: commonAPI.reducer,
        [timeSheetLogAPI.reducerPath]: timeSheetLogAPI.reducer,
        [tasktodoAPI.reducerPath]:tasktodoAPI.reducer,
        [teamResourcePlanningAPI.reducerPath]:teamResourcePlanningAPI.reducer,
        [teamTaskAPI.reducerPath] : teamTaskAPI.reducer,
        [teamboardAPI.reducerPath]:teamboardAPI.reducer,
        [attachedTaskAPI.reducerPath]:attachedTaskAPI.reducer,
        [bugTaskAPI.reducerPath]:bugTaskAPI.reducer,
        [securityPermissionAPI.reducerPath]:securityPermissionAPI.reducer,
        [ProjectDomain.reducerPath]:ProjectDomain.reducer,
        [projectTypeAPI.reducerPath]:projectTypeAPI.reducer,
        [projectEnvironment.reducerPath]:projectEnvironment.reducer,
        [projectSynergyAPI.reducerPath]:projectSynergyAPI.reducer,
        [projectOverviewAPI.reducerPath]:projectOverviewAPI.reducer,
        [planningStatusAPI.reducerPath]:planningStatusAPI.reducer,
        [statusCategoryAPI.reducerPath]:statusCategoryAPI.reducer,
        [timesheetReportAPI.reducerPath]:timesheetReportAPI.reducer,
        [planningReportAPI.reducerPath]:planningReportAPI.reducer,
        [dashboardAPI.reducerPath]:dashboardAPI.reducer,
        [groupManagementAPI.reducerPath]:groupManagementAPI.reducer,
        [groupProjectAPI.reducerPath]:groupProjectAPI.reducer,
        [groupMemberAPI.reducerPath]:groupMemberAPI.reducer,
    },

    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
        authAPI.middleware,
        userAPI.middleware,
        projectManagementAPI.middleware,
        projectTeamManagementAPI.middleware,
        customerAPI.middleware,
        RoleManagement.middleware,
        emailTemplateAPI.middleware,
        resetPasswordAPI.middleware,
        organizationAPI.middleware,
        projectComponentAPI.middleware,
        projectVersionAPI.middleware,
        taskTypeAPI.middleware,
        projectModuleAPI.middleware,
        priorityAPI.middleware,
        taskAPI.middleware,
        projectStatusAPI.middleware,
        taskStatusAPI.middleware,
        teamAPI.middleware,
        teamMemberAPI.middleware,
        teamOverviewApi.middleware,
        teamProjectsAPI.middleware,
        teamPlanningAPI.middleware,
        taskCommentsAPI.middleware,
        backLogAPI.middleware,
        taskattachmentAPI.middleware,
        commonAPI.middleware,
        tasktodoAPI.middleware,
        timeSheetLogAPI.middleware,
        teamResourcePlanningAPI.middleware,
        teamTaskAPI.middleware,
        teamboardAPI.middleware,
        attachedTaskAPI.middleware,
        bugTaskAPI.middleware,
        securityPermissionAPI.middleware,
        ProjectDomain.middleware,
        projectTypeAPI.middleware,
        projectEnvironment.middleware,
        projectSynergyAPI.middleware,
        projectOverviewAPI.middleware,
        planningStatusAPI.middleware,
        statusCategoryAPI.middleware,
        timesheetReportAPI.middleware,
        planningReportAPI.middleware,
        dashboardAPI.middleware,
        groupManagementAPI.middleware,
        groupProjectAPI.middleware,
        groupMemberAPI.middleware,
    )

})
setupListeners(store.dispatch)
